/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_viewer = {
    readonly isPopularSearchesEnabled: boolean | null;
    readonly " $refType": "SharedRespLinksBlock_viewer";
};
export type SharedRespLinksBlock_viewer$data = SharedRespLinksBlock_viewer;
export type SharedRespLinksBlock_viewer$key = {
    readonly " $data"?: SharedRespLinksBlock_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedRespLinksBlock_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isPopularSearchesEnabled",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "popularSearches"
        }
      ],
      "storageKey": "featureFlag(feature:\"popularSearches\")"
    }
  ]
};
(node as any).hash = '833762a6a2e47222ba83b8fb2f8153f2';
export default node;
